<template>
  <UIGrid v-bind="{ columns, items, sm }" wrapped>
    <template #cellAccepted="{ displayValue, item }">
      <template v-if="displayValue === true">
        <UIButton
          label="Go To Repo"
          variant="secondary"
          v-bind="{ size }"
          :disabled="isGoToRepoDisabled"
          @click="hanleClickGoToRepo(item)"
          @mouseup.stop
          @mousedown.stop
        />
      </template>
      <template v-else-if="displayValue === false">
        <span class="invites-grid__declined">
          <XMarkIcon aria-hidden="true" />
          Declined
        </span>
      </template>
      <template v-else>
        <UIButton
          label="Accept"
          variant="secondary"
          fill="light"
          v-bind="{ size }"
          :leading="CheckIcon"
          @click="handleClickAccept(item)"
          @mouseup.stop
          @mousedown.stop
        />
        <UIButton
          label="Decline"
          variant="danger"
          fill="light"
          v-bind="{ size }"
          :leading="XMarkIcon"
          @click="handleClickDecline(item)"
          @mouseup.stop
          @mousedown.stop
        />
      </template>
    </template>
  </UIGrid>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RepositoryInvite } from '@types'

import { EMPTY_VALUE_PLACEHOLDER } from '@/const/common'
import { ACCESS_TYPES } from '@/const'

import { useRepositoriesCollaboratorsStore } from '@/store/repositories/collaborators'

import { UIButton } from '@ui/buttons'
import { UIGrid } from '@ui/grid'
import { CheckIcon, XMarkIcon } from '@heroicons/vue/24/outline'

type Emits = {
  'go-to-repo': [data: string]
}

const emit = defineEmits<Emits>()

const size = 'xxs'

const repositoriesCollaboratorsStore = useRepositoriesCollaboratorsStore()

const sm = '1fr 1fr'
const columns = computed(() => [
  {
    name: 'email',
    caption: 'From',
    default: '2fr',
  },
  {
    name: 'name',
    caption: 'Repository',
  },
  {
    name: 'access_type',
    caption: 'Permissions',
    formatter: (item: RepositoryInvite) =>
      ACCESS_TYPES[Number(item) - 1] || EMPTY_VALUE_PLACEHOLDER,
    default: '120px',
  },
  {
    name: 'accepted',
    caption: '',
    unsortable: true,
    cellValueClasses: '!overflow-visible ui-grid__cell--text-right',
    default: '180px',
  },
])

const items = computed(() =>
  repositoriesCollaboratorsStore.getInvites.map(item => ({
    ...item,
    email: item.inviter?.email || '',
    name: item.repository?.name || '',
  })),
)

const unAnsweredInvites = computed(
  () =>
    !!repositoriesCollaboratorsStore.getInvites?.filter(
      invite => invite.accepted === undefined,
    ).length,
)

const isGoToRepoDisabled = computed(() => unAnsweredInvites.value)

const handleClickAccept = (item: RepositoryInvite) => {
  if (!item.id) return
  repositoriesCollaboratorsStore.acceptInvite(item.id)
}

const handleClickDecline = (item: RepositoryInvite) => {
  if (!item.id) return
  repositoriesCollaboratorsStore.declineInvite(item.id)
}

const hanleClickGoToRepo = (item: RepositoryInvite) => {
  emit('go-to-repo', item.repository.id)
}
</script>

<style>
.invites-grid__declined {
  @apply flex items-center gap-1 text-red-900;

  svg {
    @apply w-4 h-4;
  }
}
</style>
